import 'react-widgets/lib/less/react-widgets.less';
import '../style/site.less';
import React from 'react';
import ReactDOM from 'react-dom';
import { AppStore } from './store';
import { AppRouter } from './AppRouter';
import { Provider } from 'react-redux';
import {} from './Setup';
// support linq style syntax on arrays
import {} from './util/LinqPolyfill';
// support string helper functions
import {} from './util/stringHelper';
import * as Sentry from "@sentry/react";
import { Helmet } from 'react-helmet';
//import AuthProvider from './AuthProvider';
//import { AzureAD, AuthenticationState } from 'react-aad-msal';
 
  
const container = document.querySelector( '#container' );
class YourClassComponent extends React.Component {  
 
  render() {
    // This is to clear any cookies that build up because of authetication issue with old msal js lib
    //
    const cookies = document.cookie.split(";");
    for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        const eqPos = cookie.indexOf("=");
        const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        console.log('Cookie: ' + name) ;
        if (name.startsWith('msal')) {
          document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;";
          console.log('Cookie set to expire: ' + name) ;
        }
    }
    return <><Helmet>
                <meta property="og:type" content="website" />
                <meta property="og:description" content="eConfigure Devices streamlines low voltage product configuration and accessorizing for Smart Power and Smart Building. Easily configure breakers, add accessories, and generate a Bill of Materials to simplify and speed up project planning." />
                <meta name='description' content='eConfigure Devices streamlines low voltage product configuration and accessorizing for Smart Power and Smart Building. Easily configure breakers, add accessories, and generate a Bill of Materials to simplify and speed up project planning.'/>
              </Helmet>
              <Provider store={ AppStore }>
                <AppRouter />
              </Provider>
            </>  
}
}
 
// site should only load after all scripts were loaded
window.onload = () => {
  Sentry.init({
    dsn: "https://0946c5f86a6c85d436083b5f3444368c@tracing.electrificationtools.abb.com/158",
    environment: "Staging",
    sendDefaultPii:true,
    attachStacktrace:true,
    debug:false,
    tracesSampleRate:1.0 
  })
  ReactDOM.render(
    // <AzureAD provider={ AuthProvider } forceLogin={ true }>
    //   {
    //     ( { login, logout, authenticationState })=> {
    //     switch( authenticationState ) {
    //       case AuthenticationState.Authenticated :
    //         return ( <Provider store={ AppStore }>
    //                   <AppRouter />
    //                 </Provider> );
    //       case AuthenticationState.Unauthenticated:
    //         return ( <button onClick={login}>Login</button> );
    //       case AuthenticationState.InProgress :
    //         return ( <p>Authenticating...</p> );
    //   }}}    
    // </AzureAD>,
   
        <YourClassComponent />
    ,
    container );
};